import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';

import useScrollElementOnMount from 'client/hooks/useScrollElementOnMount';

import WrapperZoomInWithBlurBg from 'components/WrapperZoomInWithBlurBg';

export default function EmptyTaskPrizePopup({ open, onClose = () => {} }) {
    const bindRef = useScrollElementOnMount({ trigger: open });

    return (
        <WrapperZoomInWithBlurBg open={open}>
            {() => (
                <div css={wrap} ref={bindRef}>
                    <div css={[prizeCommonStyle, prizeFinishedStyle]}>
                        <p className="prizeFinishedTitle">
                            {i18n.t('label.game_checkIn.signInPopup.prizeIsNoStock')}
                        </p>
                        <p className="prizeFinishedCotainer">
                            {i18n.t('label.game_checkIn.signInPopup.prizeIsNoStock.desc')}
                        </p>
                        <button className="button" css={buttonCommomStyle} onClick={onClose}>
                            {i18n.t('btn.ok')}
                        </button>
                    </div>
                </div>
            )}
        </WrapperZoomInWithBlurBg>
    );
}

const prizeCommonStyle = css`
    text-align: center;
    width: 100%;
    max-width: 350px;
    background: #ffffff;
    box-shadow: 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%),
        0px 5px 5px -3px rgb(0 0 0 / 20%);
    border-radius: 16px;
`;

const buttonCommomStyle = css`
    width: 100%;
    background: #02a0fc;
    border-radius: 50px;
    border: none;
    color: #ffffff;
    font-weight: 500;
    cursor: pointer;
`;

const prizeFinishedStyle = css`
    padding: 16px 0;
    .prizeFinishedTitle {
        font-size: 24px;
        line-height: 24px;
        margin: 16px;
    }
    .prizeFinishedCotainer {
        font-size: 16px;
        line-height: 20px;
        margin: 48px 16px;
    }
    .button {
        max-width: 144px;
        max-height: 48px;
        font-size: 16px;
        line-height: 48px;
        margin: 0 0 8px 0;
    }
`;

const wrap = css`
    max-width: 720px;
    right: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
`;
